import React, { useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import SideBar from "../components/knowledgeSidebar.js";
import DocumentIntelligence from "./DocumentIntelligence.js";
import Header from "../components/Header.js";
 
const drawerWidth = 260; // Sidebar width
 
const KnowledgeX = ({ children }) => {
    const [selectedPage, setSelectedPage] = useState("document_intelligence");
 
    const handleNavigation = (page) => {
        setSelectedPage(page);
    };
    
    return (
        <>
            <CssBaseline />
            <Box sx={{ display: "flex",textAlign:"center",backgroundColor: "#282c34", color:"white",position:"absolute",top:0, bottom:0, left:0, right:0, overflow: "hidden"}}>
                <Header/>
                {/* Fixed Sidebar */}
                <Box
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        position: "fixed",
                        left: 0,
                        top: "80px", // Start below header
                        height: "calc(100vh - 80px)", // Full height minus header
                        overflowY: "auto",
                        zIndex: 1000,
                        backgroundColor: "#282c34",
                    }}
                >
                    <SideBar selectedPage={selectedPage} handleNavigation={handleNavigation} />
                </Box>
                
                {/* Full-width content area */}
                <Box component="main" sx={{
                    flexGrow: 1,
                    marginLeft: `${drawerWidth}px`,
                    width: `calc(100% - ${drawerWidth}px)`,
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflowY: "auto",
                }}>
                    {selectedPage === "document_intelligence" && <DocumentIntelligence />}
                </Box>
            </Box>
        </>
    );
};
 
export default KnowledgeX;

